var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"wordcloud"}}):_c('loading-spinner',{staticClass:"__loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }